<template>
    <div class="automation-builder">
        <CompassLoader v-if="isLoadingAutomation" size="large" class="automation-builder__loader" />
        <div v-else-if="showAutomation">
            <div id="builder-app" class="automation-builder__container"></div>
        </div>
        <div v-else class="automation-builder__empty-state--container">
            <CompassBackForwardButton
                :label="$t.__('common.actions.back')"
                :link="'javascript:history.back();'"
                type="secondary"
                back
                class="automation-builder__empty-state--redirection"
            />
            <div class="automation-builder__empty-state">
                <AutomationEmptyStateDisconnectedToProvider :showButton="false" />
            </div>
        </div>
    </div>
</template>

<script>
import AutomationEmptyStateDisconnectedToProvider from 'vcomponents/automation/AutomationEmptyStateDisconnectedToProvider.vue';
import { createNamespacedHelpers } from 'vuex';
import Env from 'Services/Env';

const { mapState: mapStateSystem } = createNamespacedHelpers('system');

export default {
    components: {
        AutomationEmptyStateDisconnectedToProvider,
    },
    data() {
        return {
            currentAutomationID: this.$route.params.id,
            isLoadingAutomation: true,
            bearer: null,
        };
    },
    computed: {
        ...mapStateSystem(['errorsHandler']),
        showAutomation() {
            return this.bearer && this.currentAutomationID;
        },
    },
    async created() {
        this.isLoadingAutomation = true;
        await this.initAutomationProvider();
        if (this.bearer) {
            this.isLoadingAutomation = false;
            window.activepieces
                .configure({
                    prefix: '/',
                    instanceUrl: Env.get('activepieces'),
                    jwtToken: this.bearer,
                    embedding: {
                        containerId: 'builder-app',
                        builder: {
                            disableNavigation: true,
                            hideLogo: true,
                            hideFlowName: false,
                        },
                        dashboard: {
                            hideSidebar: true,
                        },
                        hideFolders: true,
                        navigation: {
                            handler: ({ route }) => {
                                if (!route.startsWith(`/flows/${this.currentAutomationID}`)) {
                                    this.bearer = null;
                                    if (this.$route.name !== 'automations.listing') {
                                        this.$router.push({
                                            name: 'automations.listing',
                                        });
                                        this.$pushToast({
                                            type: 'error',
                                            close: true,
                                            text: this.$t.__('common.labels.toast.error'),
                                        });
                                    }
                                }
                            },
                        },
                    },
                })
                .then(() => {
                    window.activepieces.navigate({ route: `/flows/${this.currentAutomationID}` });
                });
        } else {
            this.isLoadingAutomation = false;
        }
    },
    methods: {
        initAutomationProvider() {
            return axios
                .get('/automations/bearer')
                .then((response) => {
                    this.bearer = response.data;
                })
                .catch((error) => {
                    this.errorsHandler.logException(error);
                });
        },
    },
};
</script>

<style lang="scss">
#contentDiv.has-sidebar-closed:has(.automation-builder) {
    padding: 60px 0 0 62px !important;
}
.contentmargin:has(.automation-builder) {
    height: initial !important;
}
</style>

<style lang="scss">
.automation-builder__container iframe {
    height: 100%;
}
</style>

<style lang="scss" scoped>
.automation-builder {
    height: 100%;

    &__loader {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
    }

    &__container {
        position: relative;
        height: 100%;
    }

    &__empty-state {
        height: 100%;
        display: flex;
        justify-content: space-around;
        align-items: center;

        &--container {
            height: 100%;
        }
        &--redirection {
            display: flex;
            justify-content: flex-start;
            margin: var(--spacing-3);
        }
    }
}
</style>
